import { useContext } from 'react';
import { createContext } from 'react';

import { ProductSpecificationValuesProps } from '../@types/ProductSpecificationValuesProps';

export const ProductSpecificationValuesContext = createContext<ProductSpecificationValuesProps>(
	{} as ProductSpecificationValuesProps,
);

ProductSpecificationValuesContext.displayName = 'ProductSpecificationValues';

const ProductSpecificationValuesProvider = (props: ProductSpecificationValuesProps) => (
	<ProductSpecificationValuesContext.Provider value={props}>
		{props.children}
	</ProductSpecificationValuesContext.Provider>
);

export const useProductSpecificationValues = () => {
	const context = useContext(ProductSpecificationValuesContext);

	return context;
};

export default ProductSpecificationValuesProvider;
